import { useDraggable } from "@dnd-kit/core";

import { ChecklistItem } from "modules/ChecklistsDashboard/components/ChecklistsList/components";
import { classNames } from "utils/common";

import type { Checklist, ChecklistID } from "models";
import type { CHECKLIST_LISTS } from "modules/ChecklistsDashboard/util";

type DraggableChecklistItemProps = {
  checklist: Checklist;
  list: CHECKLIST_LISTS;
  onClick: (checklistID: ChecklistID) => void;
};

export const DraggableChecklistItem = ({ checklist, list, onClick }: DraggableChecklistItemProps) => {
  const { setNodeRef, attributes, listeners, isDragging } = useDraggable({ id: checklist.id, data: { list } });

  return (
    <div ref={setNodeRef} className={`draggable-checklist-item ${classNames({ "is-dragging": isDragging })}`} {...attributes} {...listeners}>
      <ChecklistItem checklist={checklist} onClick={() => onClick(checklist.id)} />
    </div>
  );
};
